import { useState } from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import MyAssignment from "./MyAssignment";
import WorkItem from "./WorkItem";
import AllItem from "./AllItem";
import {
  MasterButton,
  MasterDialog,
  MasterConfirmDialog,
} from "../static/Masterpage";

const WorklistTabPanel = ({ children, value, index }) => {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      sx={{
        width: "100%",
      }}
    >
      {value === index && (
        <Box
          sx={{
            width: "100%",
            pt: 1.5,
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  );
};

const Worklist = () => {
  const [value, setValue] = useState(0);
  const [addShow, setAddShow] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const addHandleShow = () => {
    setAddShow(true);
  };

  const addHandleClose = () => {
    setIsConfirmOpen(true);
  };

  const handleClose = () => {
    setAddShow(false);
  };

  const handleConfirmClose = () => {
    setIsConfirmOpen(false);
    setAddShow(false);
  };

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100%",
        px: { xs: 1, sm: 1.5 },
        py: 1,
        backgroundColor: "#F5F8FC",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#FFFFFF",
          border: "1px solid #DCE5EE",
          borderRadius: "10px",
          overflow: "hidden",
          boxShadow: "0 2px 8px rgba(18,59,93,0.08)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            px: { xs: 1.5, sm: 2 },
            py: 1.25,
            borderBottom: "1px solid #E2E8F0",
            backgroundColor: "#FFFFFF",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: { xs: 1.5, sm: 2.5 },
              flexWrap: "wrap",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.75,
              }}
            >
              <Box
                sx={{
                  width: 18,
                  height: 18,
                  borderRadius: "4px",
                  backgroundColor: "#FF3B30",
                  border: "1px solid #D92C23",
                }}
              />
              <Typography
                sx={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#526273",
                }}
              >
                Hot Work
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.75,
              }}
            >
              <Box
                sx={{
                  width: 18,
                  height: 18,
                  borderRadius: "4px",
                  backgroundColor: "#087FF5",
                  border: "1px solid #0668C7",
                }}
              />
              <Typography
                sx={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#526273",
                }}
              >
                Cold Work
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.75,
              }}
            >
              <Box
                sx={{
                  width: 18,
                  height: 18,
                  borderRadius: "4px",
                  backgroundColor: "#FFB6C1",
                  border: "1px solid #F09AAA",
                }}
              />
              <Typography
                sx={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#526273",
                }}
              >
                Overdue
              </Typography>
            </Box>
          </Box>

          <MasterButton
            variant="primary"
            tooltip="Create new Permit to Work"
            onClick={addHandleShow}
          >
            New
          </MasterButton>
        </Box>

        <Box
          sx={{
            width: "100%",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant="fullWidth"
            aria-label="worklist tabs"
            sx={{
              minHeight: 50,
              backgroundColor: "#FFFFFF",
              borderBottom: "1px solid #DCE5EE",
              "& .MuiTabs-flexContainer": {
                width: "100%",
              },
              "& .MuiTab-root": {
                flex: 1,
                minHeight: 50,
                textTransform: "none",
                fontSize: 14,
                fontWeight: 600,
                color: "#64748B",
                backgroundColor: "#FFFFFF",
                transition: "background-color 0.2s ease, color 0.2s ease",
              },
              "& .MuiTab-root:hover": {
                color: "#123B5D",
                backgroundColor: "#F6F9FC",
              },
              "& .MuiTab-root.Mui-selected": {
                color: "#123B5D",
                backgroundColor: "#EEF5FB",
                fontWeight: 700,
              },
              "& .MuiTabs-indicator": {
                height: 3,
                backgroundColor: "#123B5D",
              },
            }}
          >
            <Tab
              label="My Assignments"
              id="simple-tab-0"
              aria-controls="simple-tabpanel-0"
            />
            <Tab
              label="All Items"
              id="simple-tab-1"
              aria-controls="simple-tabpanel-1"
            />
          </Tabs>

          <WorklistTabPanel value={value} index={0}>
            <MyAssignment
              refresh={refresh}
              setRefresh={setRefresh}
              onHide={addHandleClose}
            />
          </WorklistTabPanel>

          <WorklistTabPanel value={value} index={1}>
            <AllItem
              refresh={refresh}
              setRefresh={setRefresh}
              onHide={addHandleClose}
            />
          </WorklistTabPanel>
        </Box>
      </Box>

      <MasterDialog
        open={addShow}
        onHide={addHandleClose}
        title="Create PTW"
        maxWidth="xl"
      >
        <WorkItem onHide={handleClose} setRefresh={setRefresh} />
      </MasterDialog>

      <MasterConfirmDialog
        show={isConfirmOpen}
        title="Close Confirmation"
        message="Are you sure you want to close?"
        onConfirm={handleConfirmClose}
        onCancel={() => setIsConfirmOpen(false)}
      />
    </Box>
  );
};

export default Worklist;
